function GetSuggestedProducts() {

    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSuggestedProducts",
            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors a.active:first").attr("data-id"),
            cache: false,
            success: function (dt) {


                $(".Suggesteds").remove();

                if (dt != "") {

                    $(dt).insertBefore($(".SuggestAndLast"));


                    $(".Suggesteds .Productsuggest .ProductList .Prd").addClass("col-sm-6");
                    $(".Suggesteds .Productsuggest .ProductList .Prd").addClass("col-xs-12");
                    $(".Suggesteds .Productsuggest .ProductList .Prd:gt(3)").addClass("hidden-xs");
                }

            }
        });
    }
}

function AddProductInformationToDataLayer(id, name, category, brand, variant, price, quantity) {
    ga('ec:addProduct', {
        'id': id,
        'name': name,
        'category': category,
        'brand': brand,
        'variant': variant,
        'price': price,
        'quantity': quantity
    });

    ga('ec:setAction', 'add');
    ga('send', 'event', 'UX', 'click', 'add to cart');     // Send data using an event.
}
function ModalImageSize() {

    var ModalWidth = $("#ZoomImage > .modal-dialog").width();
    $(".ProductBigSeen > img").width(ModalWidth);


}

//Array.prototype.contains = function (obj) {
//    var i = this.length;
//    while (i--) {
//        if (this[i] === obj) {
//            return true;
//        }
//    }
//    return false;
//}

//function SameImageRemover() {
//    var ProdImages = [];
//    $(".SmallImageList > li").each(function () {
//        $Img = $(this).find("img");
//        if (ProdImages.contains($Img.attr("src"))) {

//        }
//    });

//}







function GetHashImage() {

    //var CurHash = window.location.hash;

    //if (CurHash != undefined && CurHash.length > 0 && CurHash.indexOf("#C=") > 0) {
    //    CurHash = CurHash.replace("#", "");
    //    var newHash = CurHash.replace("#", "").split("=")[1];
    //    $colorID = $(".ProductDetail .Colors a[data-id=" + newHash + "]");

    //    if ($colorID.length > 0) {
    //        $colorID.trigger("click");
    //    }

    //}

    if (window.location.hash != undefined && window.location.hash != "") {

        var colorHash = window.location.hash.split("=");
        var ColorID = colorHash[1];

        currentColorID = $(".Colors a.active:first").attr("data-id");

        if (currentColorID == ColorID) {

            //RunSlickSlider();
        }

        if (currentColorID != ColorID) {

            if ($(".ProductDetail .Colors a[data-id='" + ColorID + "']").length > 0) {

                $(".ProductDetailImages img").remove();
                $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");

            }

        }
        else if ($("#CurCatalogID").length > 0) {

            GetSuggestedProducts();
            //GetCombineProducts();
        }
    }
    else {
        //RunSlickSlider();
    }

}

var LastVisitedPrds = [];

function GetLastVisitedPrdView(productData) {

    if ($(".AutoGetLastVisited").length > 0) {

        //var prdDataList = "";
        //for (var i = 0; i < productData.length; i++) {

        //    prdDataList += "lastviewedPrds.[" + i + "].Amount=" + productData[i].Amount;
        //    LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, ProductName: _prdname });

        //}
        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProductsView",
            data: JSON.stringify(productData),
            //contentType:"text/html",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {


                $(".LastViewedProducts.AutoSetted").remove();

                if (dt != "") {

                    $(".AutoGetLastVisited").append(dt);
                    
                    $(".LastViewedProducts .ProductList .Prd").addClass("col-sm-6");
                    $(".LastViewedProducts .ProductList .Prd").addClass("col-xs-12");
                    $(".LastViewedProducts .ProductList .Prd a .img2").remove();
                    $(".LastViewedProducts .ProductList .Prd").each(function () {
                        $(this).find("a img").attr("src", $(this).find("a img").attr("src").replace("?height=280&mode=crop", "?height=280&width=280&mode=crop"))
                    });
                }

            }
        });
    }
}


$("#SingOut").live("click", function (e) {
    if (!isAppleMobile()) {
        localStorage.removeItem("LastVisitedPrds");
    }

});

function SetLastVisitedProductsStorage() {

    if (typeof (Storage) !== "undefined") {

        if ($(".ProductHeader:first").length > 0) {

            var hours = 8; // Reset when storage is more than 24hours
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('prdLastSetupTime');

            if (setupTime == null) {
                localStorage.setItem('prdLastSetupTime', now)
            } else {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.removeItem("LastVisitedPrds");
                    localStorage.setItem('prdLastSetupTime', now);
                }
            }

            var _productid = $("#ProductID:first").val();
            var _colorid = $("#ColorID:first").val();
            var _url = window.location.pathname;
            var _prdImg = $("#FirstAngle:first").val();//$("meta[property$=image]").attr("content");
            var _prdname = $(".ProductHeader:first").text();
            var _amount = $(".PriceItem:first").text();


            _prdname = _prdname.replace(/(\r\n|\n|\r)/gm, "").trim();

            LastVisitedPrds = localStorage.LastVisitedPrds;

            if (LastVisitedPrds == undefined) {
                LastVisitedPrds = [];
            } else {
                LastVisitedPrds = JSON.parse(LastVisitedPrds);
            }




            var itemExist = false;

            for (var i = 0; i < LastVisitedPrds.length; i++) {

                if (LastVisitedPrds[i].ColorID == _colorid && LastVisitedPrds[i].ProductID == _productid) {
                    itemExist = true;
                }
            }

            if (!itemExist) {

                LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, Img2: _prdImg, ProductName: _prdname });

                //if (LastVisitedPrds.length > 4) {
                //    LastVisitedPrds.splice(1, 4);
                //}

                if (LastVisitedPrds.length > 4) {
                    LastVisitedPrds.shift();
                }

                localStorage.LastVisitedPrds = JSON.stringify(LastVisitedPrds);
            }

            if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
                //console.warn(LastVisitedPrds);
                //console.log("geldi - 2#");
                GetLastVisitedPrdView(LastVisitedPrds);
            }


        }
    } else {
        console.warn("Tarayıcının localstorage desteği bulunmuyor.");
    }

}



function Get5thAngleCombine() {

    if ($(".CombineProductsOnPd .Prd").length > 0) {

        var imagePath1thAngle = $(".CombineProductsOnPd .Prd:first .img1").attr("src");

        var ImgExist = false;
        var BeginAngle = 5;
        var NewImagePathAngle = "";
        $curImg = $(".CombineProductsOnPd .ProductList .Prd:first .img1");

        if (!ImgExist && $curImg.attr("src").indexOf("5_buyuk") <= 0) {

            NewImagePathAngle = imagePath1thAngle.replace("1_buyuk", "1_buyuk");

            ImgExist = true;

            $curImg.attr("src", NewImagePathAngle);

            $curImg.error(function () {
                $curImg.attr("src", imagePath1thAngle);
            });

        }

    }
}

function ReplaceCombineProducts() {


    if ($(".CombineProductsOnPd .Prd").length > 0) {

        //$(".CombineProductsOnPd .Prd:first").append('<div class="equals">=</div>');
        $(".CombineProductsOnPd .Prd:first > a").attr("href", $(".CombineButton").attr("href"));
        $(".CombineProductsOnPd .Prd:first .PName").html($(".CombineButton").attr("data-title"));

        $priceSpan = $(".CombineProductsOnPd .Prd:first .PPrice span").clone();
        $combineButton = $(".CombineInfoPd .CombineButton").clone();

        $(".CombineProductsOnPd .Prd:first .PPrice").remove();
        $(".CombineProductsOnPd .Prd:first").append($combineButton);

        $(".CombineProductsOnPd .Prd:gt(0)").addClass("SmallPrd");

        Get5thAngleCombine();

    }

}

function GetCombineProducts() {

    if ($("#CurCatalogID").length > 0 && $(".CombineItems").length > 0) {

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetCombineProducts",
            data: "ProductID=" + $("#ProductID").val() + "&ColorID=" + $(".Colors a.active:first").attr("data-id"),
            cache: false,
            success: function (dt) {

                $(".CombineProductsOnPd").remove();

                if (dt != "") {

                    $(".SuggestAndLast.CombineItems").append(dt);
                    ReplaceCombineProducts();

                    $(".Suggesteds .Productsuggest .ProductList .Prd").addClass("col-sm-6");
                    $(".Suggesteds .Productsuggest .ProductList .Prd").addClass("col-xs-12");

                    $(".Suggesteds .Productsuggest .ProductList .Prd:gt(3)").addClass("hidden-xs");

                    $(".CombineProductsOnPd .ProductList .Prd:first").removeClass("col-xs-12").addClass("col-xs-24");

                    $(".CombineProductsOnPd .ProductList:first-child").removeClass("col-md-4").addClass("col-md-5");
                    $(".CombineProductsOnPd .ProductList:first-child").css("padding-right", "10px");



                    Get5thAngleCombine();
                }

            }
        });
    }
}

function DetailResizing() {

    $(".Productsuggest .ProductList").addClass("col-md-24")
    if ($(window).width() <= 991) {

        $(".ProductDetailsMainImage ul li img").each(function () {
            $(this).attr("src", $(this).attr("src").replace("?width=550", ""))
        });
    }



    $(".LastViewedProducts .ProductList  .Prd").each(function () {
        console.log($(window).width());
        if ($(window).width() <= 991) {
            $(this).removeClass("col-sm-6");
            $(this).removeClass("col-xs-12");
            $(this).addClass("col-xs-4");

            $(this).removeClass("col-sm-6");
            $(this).removeClass("col-sm-12")
            $(this).addClass("col-sm-4")

        } else {

            $(this).addClass("col-xs-12");
            $(this).removeClass("col-xs-4");

            $(this).addClass("col-sm-12")
            $(this).removeClass("col-sm-4");

        }
    });


    $(window).resize(function () {


        if ($(window).width() <= 991) {

            $(".ProductDetailsMainImage ul li.ImgArea img").each(function () {
                $(this).attr("src", $(this).attr("src").replace("?width=550", ""))
            });
        }


        //$(".LastViewedProducts .ProductList  .Prd").each(function () {
        //    if ($(window).width() <= 991) {
        //        $(this).removeClass("col-xs-12");
        //        $(this).addClass("col-xs-4");

        //        $(this).removeClass("col-sm-12")
        //        $(this).addClass("col-sm-4")
        //    } else {
        //        $(this).addClass("col-xs-12");
        //        $(this).removeClass("col-xs-4");

        //        $(this).addClass("col-sm-12")
        //        $(this).removeClass("col-sm-4");
        //    }
        //});

        // ProductImage Url change 



    });


}


function checkBadges(){
    if ($(".Badges .BottomIcons div").length < 1) {
        $(".Badges .BottomIcons").addClass("zeroHeight");
    }
}

function closeAskQuestions() {
    $("#AskQuestion").modal("hide");
}

function AskQuestions() {
    $(".AskQuestion").live("click", function () {
        $("#AskQuestion").modal();
    });

    $(".AskQuestionForm").live("submit", function (e) {
        e.preventDefault();
        $.ajax({
            type: 'post',
            url: $(".AskQuestionForm").attr("action"),
            data: $(".AskQuestionForm").serialize(),
            async: true,
            success: function (dt) {

                if (dt.Sonuc == true) {

                    $("#Infos").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);
                    $(".AskQuestionForm").hide();
                    setInterval(closeAskQuestions, 3000);

                }
                else {

                    $("#Infos").addClass("alert-danger");
                    $("#Infos").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                    setInterval(closeAskQuestions, 3000);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }
        });

    });

    $('#AskQuestion').on('shown.bs.modal', function () {
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/AskQuestions",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {
                $("#AskQuestion  .formArea").html("");

                $("#AskQuestion  .formArea").html(dt);
                $("#AskQuestion  .formArea .HiddenItems").find("#ColorID").val($(".Colors div a.active").data("id"));
                $("#AskQuestion  .formArea .HiddenItems").find("#ProductID").val($(".Prices #ProductID").val());
            }
        });
    });
}

function SizeTable() {
    $(".SizeTable").live("click", function () {
        $("#SizeTable").modal();
    });
}



function SizeChanges() {

    $(".bedenIcons div").live("click", function () {
        var n = this,
        s = $(n).attr("data-type");

        $("#ceket").css("display", "none"),
        $("#tshirt").css("display", "none"),
        $("#pantolon").css("display", "none"),
        $("#gomlek").css("display", "none"),
        $("#triko").css("display", "none"),
        $("#disgiyim").css("display", "none"),

        $(".bedenContent  #" + s).css("display", "inherit")
    })
}


function BasketButtonFixed() {
    $(window).scroll(function () {

        if ($("body").hasClass("Scrolled")) {

            $("#Basket").addClass("BasketFixed");

        }
        else {
            $("#Basket").removeClass("BasketFixed");
        }

    });
}



function Slider() {
    if ($(window).width() > 991) {
        $('.ProductDetailsMainImage ul').slick({
            nextArrow: '<div class="PrdImgRight right-arrow"></div>',
            prevArrow: '<div class="PrdImgLeft left-arrow"></div>',
            infinite: true,
            slidesToShow: 1,
            arrows: true,
        });

        $('.SmallProductImages ul').slick({
            slidesToShow: 5,
            slidesToScroll: 2,
            asNavFor: '.ProductDetailsMainImage ul',
            centerMode: true,
            focusOnSelect: true,
            vertical: true
        });
    }
    if($("#ProductsImages img").size() < 2){
        $("#ProductsImages img").addClass("im-hide");
    }

}

function AddToFavorite() {

    var ColorID = $("#ColorID").val();
    var ProductID = $("#ProductID").val();


    $(".passiveFavorite").live("click", function () {
        $That = $(this);
        console.log("geldi");
        if (ColorID != undefined && ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
                data: 'colorID=' + ColorID + "&productID=" + ProductID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("activeFavorite");
                        $That.removeClass("passiveFavorite");
                    }


                }
            });
        }
    });


}

function removeFavorite() {

    var ProductID = $("#ProductID").val();


    $(".activeFavorite").live("click", function () {
        $That = $(this);
        console.log("geldi");
        if (ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
                data: 'id=' + ProductID + "&IsDetail=true",
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("passiveFavorite");
                        $That.removeClass("activeFavorite");
                    }


                }
            });
        }
    });


}


function collapse() {
    $(".ProductContent #panel2 panel-group .panel-heading .panel-toggle").on("click", function () {
        console.log("bread");
        $that = $(this);
        $parent = $that.parent().parent();
        $("#panel2 panel-body").removeClass("in");
        $parent.find(".panel-body").addClass("in");

    });
}


$(document).ready(function () {

    var imageMoved = false;

    //$('.ImgArea img').on('load', function () {

    //       // console.log("resim yüklendi", this);

    //        var isHorizontal = $(this).width() > $(this).height(); 
    //        console.log(isHorizontal, $(this).attr("src"), $(this).width(), $(this).height());

    //        if (isHorizontal && !imageMoved)
    //        {
    //            imageMoved = true;
    //            $li = $(this).closest("li");
    //            $li.insertBefore($(".ProductDetailsMainImage ul li:eq(2)"));
    //            $img = $li.find("img");

    //            $img.attr("src", $img.attr("src").split('?')[0]);
    //            $li.css("width", "100%");
    //        }

    //});



    AskQuestions();
    SizeTable();
    SizeChanges();
    Slider();
    
    checkBadges();

    AddToFavorite();
    removeFavorite();

    $miniImage = $('.SmallProductImages ul');

    $(".AmountOptions").hide();

    DetailResizing();

    if (!isAppleMobile()) {
        SetLastVisitedProductsStorage();

    }

    ReplaceCombineProducts();
    //ModalImageSize();
    BasketButtonFixed();


    if ($(window).width() < 767) {

        $(".ProductDetailsMainImage ul li.VideoLi").remove();
    }


    if ($(".CombineProductsOnPd .ProductList .Prd").length > 0) {
        ////$(".CombineProductsOnPd .ProductList .Prd:first").removeClass("col-xs-12").addClass("col-xs-24");
        //if ($(".CombineProductsOnPd .ProductList .Prd").size() == 3) {
        //    $(".CombineProductsOnPd .ProductList .Prd").removeClass("col-md-8").addClass("col-md-7");
        //    $(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-7").addClass("col-md-8");
        //}

        //if ($(".CombineProductsOnPd .ProductList .Prd").size() == 5) {
        //    $(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-4").addClass("col-md-5");
        //}

        //if ($(".CombineProductsOnPd .ProductList .Prd").size() == 4) {

        //    $(".CombineProductsOnPd .ProductList .Prd").removeClass("col-md-6").addClass("col-md-5");
        //    $(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-5").addClass("col-md-6");

        //}

        //$(".CombineProductsOnPd .ProductList .Prd:first-child").addClass("PrdFirstPadding");
    }

    //function setBasketContainerHeight() {
    //    var ContentHeight = $(".SepetProducts").height() - 360;
    //    $(".BasketCenterContent").height(ContentHeight);
    //    $(".BasketCenterContent").css("max-height", ContentHeight);

    //    $(window).resize(function () {
    //        var ContentHeight = $(".SepetProducts").height() - 360;
    //        $(".BasketCenterContent").height(ContentHeight);
    //        $(".BasketCenterContent").css("max-height", ContentHeight);
    //    });

    //}

    //SEPETE EKLE
    $(".AddToBasket.ProductDetails #Basket").live("click", function (e) {


        var SizeID = $("#SizeID").val();
        var SizeDropID = $("#SizeDropID").val();
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        var Amount = $("#Amount").val();
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();

        if ($(".Drops").length <= 0) {
            SizeDropID = "yok";
        }

        $basketButton = $(this);


        if (SizeDropID != undefined && SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeDropID != "" && SizeID != "" && ColorID != "" && ProductID != "") {
            var SizeDrop = "";
            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            if (SizeDropID == "yok") {
                SizeDrop = "";
            }
            else {
                SizeDrop = "&SizeDropID=" + SizeDropID;

            }

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID + SizeDrop,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if ($(window).width() < 768) {
                        $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    }
                    else {
                        $basketButton.text(NormalText);
                    }

                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    AddProductInformationToDataLayer
                        (
                        dt.JsonRs.id,
                        dt.JsonRs.name,
                        dt.JsonRs.category,
                        dt.JsonRs.brand,
                        dt.JsonRs.variant,
                        dt.JsonRs.price,
                        dt.JsonRs.quantity
                        );

                    if (dt.Sonuc == true) {

                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {

                                $("#UserMenus  #UserAndBasket").html(dt);

                                $('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");

                                $(".SepetProducts").hide();
                                $(".SepetProducts").addClass("activeBasket");
                                setBasketContainerHeight();
                                $(".AjaxLoader").hide();



                            }
                        });


                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);

                            // console.log("basketParams:" + basketParams);
                        }

                        if (UseTagManager) {

                            SendCartAddEvent('');
                        }


                    }
                    else {

                        alert(dt.IslemSonucAciklama);
                    }


                }
            });




        }
        else {

            if (SizeDropID == undefined || SizeDropID == "") {
                $("#PrdBlackBg").show();
                $(".DropItems").addClass("PleaseSelect");
                $(".AddToBasket").addClass("PleaseSelect");
                $('html, body').animate({
                    scrollTop: $(".DropItems").offset().top - 150
                }, 500);

            }

            if (SizeID == undefined || SizeID == "") {


                $("#PrdBlackBg").show();
                $(".SizeOptions.open").addClass("PleaseSelect");
                $(".AddToBasket").addClass("PleaseSelect");
                //$("body").addClass("BackDropped");

                $('html, body').animate({
                    scrollTop: $(".SizeOptions").offset().top - 150
                }, 500);


                if ($(".AutoTextRep").length > 0) {

                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ColorID == undefined || ColorID == "") {

                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);


        }

        e.preventDefault();
        return false;

    });

    

    //$('.Drops .dropItem').live("click", function () {

    //    $(".dropItem").removeClass("active");
    //    $(this).parents().parent().find("#SizeDropID").val($(this).attr("data-id"));
    //    $(this).addClass("active");

    //    if ($(".DropItems.PleaseSelect").length > 0)
    //    {
    //        $(".DropItems.PleaseSelect").removeClass("PleaseSelect");
    //        $(".AddToBasket").removeClass("PleaseSelect");
    //        $("#PrdBlackBg").hide();
    //        $(".AddToBasket #Basket").click();
    //    }

    //});

    //Ürün Beden Seçimi
    $('.SizeOptions a:not(.NotifyWhen)').live("click", function () {

        $(this).parents(".Sizes").find(".Name").html($(this).attr("data-name"));
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));

        $(this).parent().find("a").removeClass("active");
        $(this).addClass("active");



        if ($(".NewPD").length > 0) {

            $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("passed");

            $(".Colors span.ChooseTitle").removeClass("current");
            $(".Colors span.ChooseTitle").addClass("passed");

            $(".Sizes span.ChooseTitle").removeClass("current");
            $(".Sizes span.ChooseTitle").addClass("passed");

            $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
            $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");

            $(".AmountOptions  span.ChooseTitle").removeClass("passed");
            $(".AmountOptions  span.ChooseTitle").addClass("current");


            var TrigAddBasket = false;

            if ($(".SizeOptions.PleaseSelect").length == 1) {
                TrigAddBasket = true;
            }


            //$(".AmountOptions").addClass("open");

            $(".AddToBasket button").removeClass("NotSelected");


            if ($(".AutoTextRep").length > 0 && $(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0 && $(".EsPD").length <= 0) {

                $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
            }

            $(".SizeOptions").removeClass("PleaseSelect");

            $(".DropItems.PleaseSelect").removeClass("PleaseSelect");
            $(".AddToBasket").removeClass("PleaseSelect");

            $("#PrdBlackBg").hide();

            if (TrigAddBasket) {
                $(".AddToBasket #Basket").click();
            }

        }

        if ($(".LastProducts").length > 0) {

            var params = "ProductID=" + $("#ProductID").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $("#SizeID").val();

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/StokWarn",
                data: params,
                success: function (data) {

                    if (data != "0" && data != 0) {

                        var prdCls = "More";

                        $(".LastProducts").removeClass("One");
                        $(".LastProducts").removeClass("Two");
                        $(".LastProducts").removeClass("More");
                        $(".LastProducts").removeClass("Limited");

                        $(".LastX").html(data);
                        $(".LastPrdHint").html($(".LastPrdHint").attr("data-more"));

                        if (data.length > 1) {
                            $(".LastX").css("margin-left", "2px");
                        }
                        else {
                            $(".LastX").css("margin-left", "4px");
                        }

                        switch (data) {

                            case "1": prdCls = "One"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-one")); break;
                            case "2": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                            case "3": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                            case "": prdCls = "gizli"; $(".LastPrdHint").html(""); break;
                            case "4": prdCls = "Limited"; break;

                        }

                        $(".LastProducts").addClass(prdCls);

                    }
                }

            });

        }


    });

    if ($(".SizeOptions .ONE.SIZE").length > 0) {

        $(".SizeOptions .ONE.SIZE").trigger("click");
        //$(".SizeAndAmount").hide();
    }


    $("a.NotifyWhen").live("click", function myfunction() {

        $("#NotifyModal").modal("show");


        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetListForRemind?ProductID=" + $("#ProductID:first").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $(this).parent().parent().parent().find("input[name=SizeIDs]").val(),
            cache: true,
            success: function (data) {

                $("#NotifyModal .modal-body").html(data);
                $(".NotifyColors a:first").trigger("click");
            }
        });


    });

    var lastColorID = 0;

    if ($('.ProductDetail .Colors a.active').length > 0) {
        $(".ProductDetail .Colors .Name").html($('.ProductDetail .Colors a.active').first().attr("data-name"));
    }

    //Favorilere Ekle
    $(".PrLike.add").live("click", function () {

        if (!$(this).hasClass("active")) {

            var ColorID = $("#ColorID").val();
            var ProductID = $("#ProductID").val();
            var Notify = $(this).attr("data-notify");

            var LangID = $("#LangID").val();

            var clickedItem = $(this);

            if (ColorID != undefined && ProductID != undefined && ColorID != "" && ProductID != "") {

                $.ajax({
                    url: '/Cart/AddToFollowList',
                    data: "colorID=" + ColorID + "&productID=" + ProductID + "&langID=" + LangID,
                    dataType: 'json',
                    success: function (dt) {

                        if (dt.Sonuc == true) {

                            $("button.PrLike").text($("button.PrLike").attr("data-infavtext"));

                            $(clickedItem).addClass("active");
                            $(clickedItem).attr("data-followid", dt.Deger1);
                            $(clickedItem).val(dt.IslemSonucAciklama);
                            $('.LikeCount').html(dt.Deger4);

                            if ($(".HeartIcon").length > 0) {
                                $(".HeartIcon").removeClass("Blank");
                                $(".HeartIcon").trigger("click");
                            }

                        }
                        else {

                            alert(dt.IslemSonucAciklama);
                        }

                    }
                });



            }
            else {

                if (ColorID == undefined || ColorID == "") alert("Lütfen bir Renk Seçininiz");
                if (ProductID == undefined || ProductID == "") alert("Ürün Bulunamadı");
            }

        }

    });

    //Favorilerden Çıkart
    $(".PrLike.active").live("click", function () {

        var clickedItem = $(this);

        var Silid = $(this).attr("data-id");

        if ($(this).attr("data-followid").length > 0) {

            Silid = $(this).attr("data-followid");

        }

        var clickedIcon = $(this);

        var LangID = $("#LangID").val();

        $.ajax({
            url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
            data: 'id=' + Silid + "&langID=" + LangID,
            dataType: 'json',
            success: function (dt) {

                if (dt.Sonuc == true) {

                    $(clickedIcon).removeClass("active");
                    $(clickedIcon).addClass("add");
                    $("button.PrLike").text($("button.PrLike").attr("data-addtext"));

                }
                else {

                    alert(dt.IslemSonucAciklama);
                }

            }
        });


    });


    if ($("#CurColor").length <= 0) {

        $('#QuickLookModal .ProductDetail .Colors a').live("click", function (e) {
            //$('.AddToRemindList').hide();
            $('#RemindModal .modal-body .alert-error').hide();
            $('#RemindModal .modal-body .remind-success').hide();
            $('.RemindInfo').show();
            $(".LastProducts").hide();

            $(this).parents(".Colors").find(".Name").html($(this).attr("data-name"));
            $(this).parents(".Colors").find("#ColorID").val($(this).attr("data-id"));
            $(this).parent().find("a").removeClass("active");
            $(this).addClass("active");

            $("#SizeID").val("");

            var colorID = $(this).attr("data-id");
            var productID = $("#ProductID").val();

            $(".AjaxLoader").show();
            var params = "ColorID=" + $(this).attr("data-id") + "&ProductID=" + $("#ProductID").val();

            if (lastColorID != $(this).attr("data-id")) {

                lastColorID = $(this).attr("data-id");

                if ($("#ProductID").length > 0 && $("#QuickLookModal").length <= 0) {

                    var newhash = "#C=" + $(this).attr("data-id");
                    window.location.hash = newhash;

                    if ($("#CurColor").length > 0) {
                        var curh1 = $("h1.ProductHeader").html();
                        curh1 = curh1.replace($("#CurColor").val(), $(this).attr("data-global"));
                        $("h1.ProductHeader").html(curh1);

                        $("#CurColor").val($(this).attr("data-global"));
                    }
                }

                var $newul = $('<ul>');

                $.ajax({
                    type: "GET",
                    url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetAllDetailInfoByColorID",
                    data: params,
                    success: function (data) {

                        $(".SmallProductImages img").remove();
                        $(".ProductDetailImages ul li.ImgArea").remove();

                        $selectSizePopup = $(".SizeOptions #SelectSizePopup");

                        if ($selectSizePopup.length > 0) {

                            $selectSizePopup = $(".SizeOptions #SelectSizePopup").clone();
                        }

                        $(".SizeOptions").html("");
                        $(".ReminderSizeOptions").html("");

                        if ($selectSizePopup.length > 0) {
                            $(".SizeOptions").append($selectSizePopup);
                        }

                        $(".PrLike").removeClass("active");
                        $(".PrLike").addClass("add");

                        var imgCount = 0;

                        for (var i = 0; i < data.length; i++) {

                            if (data[i].Type == "StockImage") {

                                var srcAttr = "src";

                                if (imgCount == 0) {
                                    //srcAttr = "data-src";
                                }

                                var $img = $('<img >');
                                $img.attr(srcAttr, data[i].Name.replace("_buyuk", "_detay"));

                                var $li = $('<li class="ImgArea">');

                                if (imgCount >= 1) {
                                    $li.addClass("gizli");
                                }

                                var $a = $('<a>');
                                $a.attr('href', data[i].Name);
                                $a.attr('class', "cloudzoomManuel cloud-zoom");

                                $a.append($img);
                                $li.append($a);

                                $li.prependTo('.ProductDetailImages ul');
                                $li.clone().prependTo($newul);

                                var $imgKucuk = $('<img >');
                                $imgKucuk.attr("src", data[i].Name.replace("_buyuk", "_kucuk"));

                                if (!isMobile(true)) {

                                    if ($("#ResmiIndir").length > 0) {

                                        $li.append($('<a class="DownloadImage" href="' + data[i].Name + '" target="_blank"><i class="icon-arrow-down"></i>' + $("#ResmiIndir").val() + '</a>'));
                                    }
                                }


                                if ($("#ChangeBasketModal").length <= 0 || imgCount < 5) {
                                    $imgKucuk.prependTo('.SmallProductImages');
                                }


                                $imgKucuk.show("slow");

                                if (!isMobile(true)) {

                                    $img.css("opacity", "0.1");

                                    $img.animate({
                                        opacity: 1
                                    }, 500, function () {


                                    });

                                }

                                imgCount++;

                            }

                            if (data[i].Type == "Size") {
                                var stil = "";
                                if (data[i].InStock == false || data[i].PStatus != 1) {

                                    stil = "OutOfQuantity";

                                    if ($(".NewPD").length > 0) {
                                        $(".SizeOptions").append('<span class=\"outer\">' +
                                            '  <span class="PdHint"> <span class="PdHint-content">Bu Ürünün ' + data[i].Name + ' Bedeni Stoklarla Kalmamıştır.<br />' +
                                                '<a href="#" class="NotifyWhen">Ürün stoğa geldiğinde haber ver!</a>' +
                                           ' </span></span>'
                                            + '<span class=\"inner\">' + data[i].Name + '</span></span>');



                                    } else {
                                        $(".SizeOptions").append('<span class=\"outer\"><span class=\"inner\">' + data[i].Name + '</span></span>');
                                    }

                                    $('.AddToRemindList').show();

                                }

                                else {
                                    $(".SizeOptions").append('<a data-id="' + data[i].ID + '" data-stock="' + data[i].InStock + '" data-name="' + data[i].Name + '" href="javascript:void(0)" class="' + stil + " " + data[i].Name + '">' + data[i].Name + '</a>');
                                }
                                $(".AjaxLoader").hide();

                            }


                            $("button.PrLike").text($("button.PrLike").attr("data-addtext"));

                            if (data[i].Type == "FollowList") {

                                $(".PrLike").removeClass("add");
                                $(".PrLike").addClass("active");
                                $(".PrLike").attr("data-followid", data[i].ID);

                                $("button.PrLike").text($("button.PrLike").attr("data-infavtext"));

                                $(".AjaxLoader").hide();

                            }


                            if (data[i].Type == "ManikinInfoes") {

                                var ManikinInfoes = data[i].Name.split("|");

                                if (ManikinInfoes != undefined && ManikinInfoes.length > 0) {

                                    $(".ManikinInfo > div").hide();
                                    $(".ManikinInfo").show();
                                    $(".ManikinImage").addClass("SizeTableImg");

                                    for (var w = 0; w < ManikinInfoes.length; w++) {

                                        var curManInfo = ManikinInfoes[w].split("=");


                                        if (curManInfo != undefined && curManInfo.length > 0) {

                                            if (curManInfo.length > 1) {

                                                $(".ManikinInfo ." + curManInfo[0] + "Con").show();
                                                $(".ManikinInfo ." + curManInfo[0] + "Con").removeClass("ManikinHidden");

                                                $(".ManikinInfo ." + curManInfo[0]).text(curManInfo[1]);


                                            }
                                        }
                                    }
                                }
                                else {
                                    $(".ManikinInfo > div").hide();
                                    $(".ManikinInfo").hide();
                                    $(".ManikinImage").removeClass("SizeTableImg");
                                }

                            }

                        }


                        if ($(window).width() > 1000 && $("#QuickLookModal").length <= 0) {
                            $(".cloud-zoom:first").CloudZoom();
                        }


                        $(".SmallProductImages > img:first").addClass("Selected");
                        $(".SmallProductImages > img:first").trigger("click");

                        //ilgili rengin önerilen ürünleri
                        GetSuggestedProducts();
                        GetCombineProducts();

                        if ($(".NewPD").length > 0) {

                            $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("open");

                            $(".Colors span.ChooseTitle").removeClass("current");
                            $(".Colors span.ChooseTitle").addClass("passed");

                            $(".SizeAndAmount span.ChooseTitle").addClass("current");
                            $(".SizeAndAmount span.ChooseTitle").removeClass("passed");

                            $(".AmountOptions span.ChooseTitle").removeClass("current");
                            $(".AmountOptions span.ChooseTitle").removeClass("passed");

                            $(".AmountOptions").removeClass("open");

                            $(".Sizes").find(".Name").html("");

                            $(".AddToBasket button").addClass("NotSelected");
                            $(".AddCombineToBasket button").addClass("NotSelected");

                            if ($(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0) {
                                $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
                            }

                            if ($(".AddCombineToBasket button").attr("data-first") != undefined && $(".AddCombineToBasket button").attr("data-first").length > 0) {
                                $(".AddCombineToBasket button").text($(".AddCombineToBasket button").attr("data-first"));
                            }


                        }

                        if (isMobile(true)) {

                            $oldUl = $(".ProductDetailImages ul:first");
                            $newul.insertAfter($(".ProductDetailImages ul:first"));
                            $oldUl.remove();

                            //RunSlickSlider();


                        }


                        if ($(".SizeOptions .ONE.SIZE").length > 0) {

                            $(".SizeOptions .ONE.SIZE").trigger("click");
                            $(".SizeAndAmount").hide();
                        }
                        else {
                            $(".SizeAndAmount").show();
                        }

                    },
                    error: function () {

                        //alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    }

                });



                if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                    var swParams = GetSwPageParams();

                    swParams = ChangeSwHashedStringParamValue(swParams, "ActionType", "UrunRenkDegistirme");

                    swParams = AddSwParam(swParams, "SubActionType", "HizliBakis");
                    swParams = AddSwParam(swParams, "ProductID", productID);
                    swParams = AddSwParam(swParams, "ColorID", colorID);

                    AddSwAction(swParams);

                }

            }

            e.preventDefault();
            return false;

        });


    }

    GetHashImage();

    $('.DropItems a.dropItem').live("click", function (e) {


        $(".Drops").find("#SizeDropID").val($(this).attr("data-id"));
        $(this).parent().find("a").removeClass("active");
        $(this).addClass("active");

        $("#SizeID").val("");

        var sizeDropID = $(this).attr("data-id");
        var productID = $("#ProductID").val();
        var colorID = $("#ColorID").val();

        $(".AjaxLoader").show();
        var params = "ColorID=" + colorID + "&ProductID=" + productID + "&SizeDropID=" + sizeDropID


        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetAllDetailInfoByDropAndColorID",
            data: params,
            success: function (data) {

                $(".SizeOptions").html("");
                $(".ReminderSizeOptions").html("");

                $selectSizePopup = $(".SizeOptions #SelectSizePopup");

                if ($selectSizePopup.length > 0) {

                    $selectSizePopup = $(".SizeOptions #SelectSizePopup").clone();
                }

                $(".SizeOptions").html("");

                if ($selectSizePopup.length > 0) {
                    $(".SizeOptions").append($selectSizePopup);
                }


                for (var i = 0; i < data.length; i++) {

                    if (data[i].Type == "Size") {
                        var stil = "";

                        if (data[i].InStock == false || data[i].PStatus != 1) {

                            $(".SizeOptions").append('<span class=\"outer\">' +
                                '  <span class="PdHint"> <span class="PdHint-content">Bu Ürünün ' + data[i].Name + ' Bedeni Stoklarla Kalmamıştır.<br />' +
                                    '<a href="#" class="NotifyWhen">Ürün stoğa geldiğinde haber ver!</a>' +
                               ' </span><i class="reactangle"></i></span>'
                                + '<span class=\"inner\">' + data[i].Name + '</span></span>');


                        }
                        else {
                            $(".SizeOptions").append('<a data-id="' + data[i].ID + '" data-stock="' + data[i].InStock + '" data-name="' + data[i].Name + '" href="javascript:void(0)" class="' + stil + " " + data[i].Name + '">' + data[i].Name + '</a>');
                        }

                        $(".AjaxLoader").hide();

                    }

                }


            },
            error: function () {

                //alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });

        e.preventDefault();
        return false;

    });



    $(window).bind('hashchange', function (e) {

        GetHashImage();

    });

    if ($("div.row.Products").length > 0) {

        var ScrollSize = +70;
        var offsetTop = 0;

        if (isMobile(true)) {
            ScrollSize = 50;
            offsetTop = $(".ToogleFilters:first").offset().top;

        } else if ($("#FilterForm").length > 0) {

            //offsetTop = $("#FilterForm").offset().top
        }

        if (isMobile(true)) {

            $('html, body').animate({
                scrollTop: offsetTop - ScrollSize
            }, 500);
        }

    }

    //if (window.location.hash != undefined && window.location.hash != "") {

    //    GetHashImage();

    //}


    //Amount Option Change
    $('.AmountOptions .BasketPlus, .AmountOptions .BasketMinus').live("click", function () {

        if ($(this).closest(".AmountOptions").hasClass("open") == false) {
            return;
        }

        if ($(this).attr("class") == "BasketPlus") {

            if ($(".AmountOptions #Amount").val() >= 9) {
                $(".AmountOptions #Amount").val(9)
            }
            else {

                $(".AmountOptions #Amount").val(parseInt($(".AmountOptions #Amount").val()) + 1);
            }
        }
        else {
            if ($(".AmountOptions #Amount").val() > 1) {
                $(".AmountOptions #Amount").val(parseInt($(".AmountOptions #Amount").val()) - 1);
            }
            else {

                $(".AmountOptions #Amount").val(1)
            }
        }

    });

    $('.ProductDetail #Amount').live("keyup", function () {

        var yeniAdet = $(this).val();
        $adetKutusu = $(this);

        if (!isNumeric(yeniAdet)) {
            yeniAdet = 1;
        }

        if (yeniAdet <= 1) {

            yeniAdet = 1;
            $adetKutusu.val(1);
        }
        else if (yeniAdet >= 9) {

            yeniAdet = 9;
            $adetKutusu.val(9);
        }

    });

    $(".AmountOptions #Amount").live("change", function () {

        if ($(".AmountOptions #Amount").val() < 1) {

            $(".AmountOptions #Amount").val(1);
        }
        else if ($(".AmountOptions #Amount").val() >= 9) {

            $(".AmountOptions #Amount").val(9);
        }

    });


    $(".SmallProductImages ul li img").live("click", function () {



        $(".SmallProductImages ul li img").each(function () {

            $(this).removeClass("Selected");

        });

        $(this).addClass("Selected");
        $Index = $(this).parent().index();
        $(".ProductDetailImages ul li.ImgArea").addClass("gizli");
        $(".ProductDetailImages ul li.ImgArea").each(function () {
            if ($Index === $(this).index()) {
                $(this).removeClass("gizli");
            }
        });

    });

    $('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {


        $(".SmallProductImages ul li").each(function () {
            if ($(this).data("slick-index") == currentSlide) {

                $("img", this).addClass("Selected");

            }
            else {

                $("img", this).removeClass("Selected");

            }



        });


    });


    $('.ProductDetailImages .ImgArea a').live("click", function (e) {

        if (isMobile(true) || $(this).closest("#QuickLookModal").length > 0) {

            return false;
            e.preventDefault();
        }

    });

    if ($(window).width() > 1000 && $(".cloudzoomManuel").length > 0 && $("#QuickLookModal").length <= 0) {

        $(".cloudzoomManuel:first").addClass("cloud-zoom").CloudZoom();

    }



    $("a.SizeTableLink").click(function () {

        $("#WarningModal .modal-header h3").html($(this).text().replace("|", ""));
        $("#WarningModal .modal-body").html("");

        $("#WarningModal").modal("show");

        var ProductID = $(this).closest(".ProductName").next(".CombineColors").find(".ProductID").val();
        var ColorID = $(this).closest(".ProductName").next(".CombineColors").find(".ColorID").val();

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/SizeChart?ProductID=" + ProductID + "&ColorID=" + ColorID,
            success: function (data) {

                $("#WarningModal .modal-body").html(data);

            }
        });

    });
    if ($(window).width() < 992) {
        $(".ProductDetailImages .PrdImgRight").click(function (e) {

            //$("#AditionalDescription").remove();

            $currentObject = $(".ProductDetailImages ul li.ImgArea");
            if ($currentObject.not(".mobile-hidden").index() == ($currentObject.length - 1)) {

                $currentObject.addClass("mobile-hidden").first(".ImgArea").removeClass("mobile-hidden");

            } else {

                $currentObject.not(".mobile-hidden").addClass("mobile-hidden").next(".ImgArea").removeClass("mobile-hidden");

            }

            $(".SmallProductImages ul li img").each(function () {
                $ItemIndex = $currentObject.not(".mobile-hidden").index();
                if ($currentObject.not(".mobile-hidden").index() == $(this).parent().index()) {
                    console.log($currentObject.not(".mobile-hidden").index());
                    $(this).addClass("Selected");
                }

                $(".SmallProductImages ul li img").each(function () {
                    if ($(this).parent().index() != $ItemIndex) {
                        $(this).removeClass("Selected");
                    }

                });
            });


        });

        $(".ProductDetailImages .PrdImgLeft").click(function (e) {

            //$("#AditionalDescription").remove();

            $currentObject = $(".ProductDetailImages ul li.ImgArea");

            if ($currentObject.not(".mobile-hidden").index() == 0) {

                $currentObject.addClass("mobile-hidden");
                $currentObject.last().removeClass("mobile-hidden");

            } else {

                $currentObject.not(".mobile-hidden").addClass("mobile-hidden").prev(".ImgArea").removeClass("mobile-hidden");

            }

            $(".SmallProductImages ul li img").each(function () {


                $ItemIndex = $currentObject.not(".mobile-hidden").index();
                if ($currentObject.not(".mobile-hidden").index() == $(this).parent().index()) {
                    console.log($currentObject.not(".mobile-hidden").index());
                    $(this).addClass("Selected");
                }

                $(".SmallProductImages ul li img").each(function () {
                    if ($(this).parent().index() != $ItemIndex) {
                        $(this).removeClass("Selected");
                    }

                });
            });

        });
    }
    if ($(window).width() < 993) {

        $(".ProductDetailImages .ImgArea  img").hammer().on("swiperight", function (e) {
            $(".PrdImgRight").trigger("click");
        });


        $(".ProductDetailImages .ImgArea  img").hammer().on("swipeleft", function (e) {
            $(".PrdImgLeft").trigger("click");
        });

    }


    var isOpen = false;
    $('.PdInstallmentOptions, .PrInstallmentOptions').live("click", function (e) {

        var Amount = $(".PriceItem:first").html();
        var isPr = $(this).hasClass("PrInstallmentOptions");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetInstallmentOptions?Amount=" + Amount.replace(".", ""),
            success: function (data) {

                isOpen = !isOpen;
                //console.log(data);
                $(".InstallmentBody").html(data);
                if (isPr) {
                    $("#PdInstallmentOptionsDetail").addClass("collapse in");
                }

                if (isOpen) {

                    $('html, body').animate({
                        scrollTop: $("#PdInstallmentOptionsDetail").offset().top - 50
                    }, 500);
                }
                if (data != null) {

                }
            }
        });

    });


    $(".PrAdvantages a").click(function (e) {
        $("#WarningModal .modal-header h3").html($(this).text().replace("|", ""));
        $("#WarningModal .modal-body").html("");
        $("#WarningModal").modal("show");
        var ProductID = $("#ProductID").val();
        var ColorID = $("#ColorID").val();
        var Amount = parseFloat($(".PriceItem:first").html());

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetAdvantages?ProductID=" + ProductID + "&ColorID=" + ColorID + "&Amount=" + Amount,
            success: function (data) {
                $("#WarningModal .modal-title").hide();
                $("#WarningModal .modal-body").html(data);
            }
        });
    });



    $(".ProductDetailImages .ProductDetailsMainImage ul li img").live("click", function () {
        $ClickedImage = $(this);
        $('.ProductBigSeen').empty();
        $('.ProductBigSeen').html("");
        //$("#ZoomImage").modal();
    });

    //$("#ZoomImage .closeImage").live("click", function () {
    //    $("#ZoomImage").modal("toggle");
    //});

    //$('#ZoomImage').on('show.bs.modal', function () {
    //    $ImageCounter = 0;
    //    $BigImageUrl = $ClickedImage.attr("src").replace("?width=550", "");
    //    $(".ProductBigSeen").append('<ul class="ProductImageList"></ul>');
    //    $(".ProductBigSeen").append('<ul class="SmallImageList"></ul>');
    //    $(".ProductDetailsMainImage ul li.ImgArea img").each(function () {
    //        var PImageWrapper = $("<li></li>");
    //        var PSImageWrapper = $("<li></li>");
    //        if ($(this).parent().index() == 0) {
    //            PImageWrapper.addClass("selectedImage")
    //            PSImageWrapper.addClass("selectedImage")
    //        }
    //        PImageWrapper.append($("<img class='ZoomModalImages' />").attr("src", $(this).attr("src").replace("?width=550", "")));
    //        $(".ProductBigSeen .ProductImageList").append(PImageWrapper);
    //        PSImageWrapper.append($("<img class='ZoomModalSmallImages' />").attr("src", $(this).attr("src").replace("_buyuk.jpg", "_kucuk.jpg")));
    //        $(".ProductBigSeen .SmallImageList").append(PSImageWrapper);

    //    });

    //    $(".ProductDetailsMainImage .ImgArea").each(function () {
    //        if ($(this).data("slick-index") > -1 && !$(this).hasClass("slick-cloned")) {
    //            $ImageCounter++;
    //        }
    //    });
    //    console.log($ImageCounter);
    //    $(".SmallImageList > li").each(function (index) {
    //        if (($ImageCounter - 1) > index) {
    //            $(this).remove();
    //        }
    //    });
    //    ModalImageSize();
    //    //SameImageRemover();

    //});

    $(".SmallImageList li").live("click", function () {
        var ImageIndex = $(this).index();
        $(".ProductImageList li").removeClass("selectedImage");
        $(".SmallImageList li").removeClass("selectedImage");
        $(this).addClass("selectedImage");
        $(".ProductImageList li").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).addClass("selectedImage");
            }
        });

    });

    //$('#ZoomImage').on('hidden.bs.modal', function () {
    //    //$('.ProductBigSeen').slick('unslick');
    //    $('.ProductBigSeen').empty();
    //    $('.ProductBigSeen').html("");
    //    $(".ThumbImageList").empty();
    //})

    $(".ThumbImageList li img").live("click", function (event) {
        event.stopPropagation();
        $sliderSlick.slick("slickGoTo", $(this).parent().index());

        $(".ThumbImageList li img").each(function () {

            $(this).removeClass("ThumbActive");

        });

        $(this).addClass("ThumbActive");

    });


    $(".ProductDetailSmallImages .SmallProductImages div:eq(0)").find("img").addClass("Selected");

    $(".ProductDetailSmallImages .SmallProductImages div").live("click", function (event) {

        //alert("dsds");
        var ImageIndex = $(this).index();

        $(".SliderMain li").addClass("gizli");

        $(".SliderMain li:eq(" + ImageIndex + ")").removeClass("gizli");

        $(".ProductDetailSmallImages .SmallProductImages div").children('img').removeClass("Selected");

        $(this).children('img').addClass("Selected")
        if ($(this).hasClass('PrdVideo') && $('video#ProductVideoControls').length > 0) {

            $('video#ProductVideoControls').get(0).play();
        }
        setZoomer();

        // RunSlickSlider();

        // var ImageIndex = $(this).parent().index();

        // $slc.slick("slickGoTo", ImageIndex);

        // $(".ProductDetailSmallImages .SmallProductImages div img").each(function () {

        //     $(this).removeClass("Selected");

        // });

        // $(this).addClass("Selected");

    }).children('div').click(function (e) {
        return false;
    });;


    $('.ProductBigSeen').on('afterChange', function (event, slick, currentSlide, nextSlide) {

        $(".ThumbImageList li img").each(function () {
            if ($(this).parent().index() == currentSlide) {
                $(this).addClass("ThumbActive");
            }
            else {
                $(this).removeClass("ThumbActive");
            }


        });




    });

    $(window).resize(function () {

        ModalImageSize();


    });




    collapse();





});
